"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  configureMotion: true
};
Object.defineProperty(exports, "configureMotion", {
  enumerable: true,
  get: function () {
    return _configureMotion.configureMotion;
  }
});
var _AnimatedComponents = require("./AnimatedComponents");
Object.keys(_AnimatedComponents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AnimatedComponents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AnimatedComponents[key];
    }
  });
});
var _createMotionComponent = require("./createMotionComponent");
Object.keys(_createMotionComponent).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _createMotionComponent[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _createMotionComponent[key];
    }
  });
});
var _Interfaces = require("./Interfaces");
Object.keys(_Interfaces).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Interfaces[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Interfaces[key];
    }
  });
});
var _AnimatePresence = require("./AnimatePresence");
Object.keys(_AnimatePresence).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _AnimatePresence[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _AnimatePresence[key];
    }
  });
});
var _configureMotion = require("./configureMotion");
//# sourceMappingURL=index.js.map